import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    })
  }

  const handleSend = () => {
    const { firstName, lastName, email, phone, message } = formDetails;
    const body = [
      `Name: ${firstName} ${lastName}`,
      `Email: ${email}`,
      phone ? `Phone: ${phone}` : null,
      ``,
      `Message:`,
      message
    ].filter(line => line !== null).join('\n');

    const subject = `Portfolio Contact from ${firstName} ${lastName}`;
    window.location.href = `mailto:gabenulman+website@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setStatus({ success: true, message: "Opening your email client..." });
  }

  return (
    <section className="contact" id="connect">
      <Container>
        <Row>
          <Col xs={12} md={8} lg={6}>
            <h2>Get In Touch</h2>
            <p className="contact-subtitle">
              Have a project in mind or just want to say hello? Fill out the form and I'll get back to you.
            </p>
            <form>
              <Row>
                <Col xs={12} sm={6} className="px-1">
                  <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                </Col>
                <Col xs={12} sm={6} className="px-1">
                  <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)} />
                </Col>
                <Col xs={12} sm={6} className="px-1">
                  <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                </Col>
                <Col xs={12} sm={6} className="px-1">
                  <input type="tel" value={formDetails.phone} placeholder="Phone (optional)" onChange={(e) => onFormUpdate('phone', e.target.value)} />
                </Col>
                <Col xs={12} className="px-1">
                  <textarea rows="6" value={formDetails.message} placeholder="Your message..." onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                  <button type="button" className="send-btn" onClick={handleSend}>
                    Send Message
                  </button>
                </Col>
                {status.message && (
                  <Col>
                    <p className={status.success ? "success" : "danger"}>{status.message}</p>
                  </Col>
                )}
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
